<template>
  <div>
    <TwTable :searchData="searchData" :tableData="tableData" :tableConfig="tableConfig" :pageConfig="pageConfig"
      :filters="filters" :buttonList="buttonList" @resetBtn="resetBtn" @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick" @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox" @searchChange="searchChange" @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle" @handleSelsChange="handleSelsChange" @handleOperateEvent="handleOperateEvent">
      <template v-slot:baseTypes>
        <el-select class="dateSelect" v-model="filters.baseTypes" placeholder="请选择">
          <el-option v-for="item in baseTypesOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </template>
    </TwTable>
    <accountAdjustmentDalog @searchTable="initTable" ref="accountAdjustmentDalogRef" />
  </div>
</template>
  
<script>
import {
  GetFeeOrgDetailList,
  FeeOrgDetailExport,
  FeeDepartmentExport
} from "@/api/costManagement/feeOrgDetailReport.js";
import {
  getFeeItemBatchBasis
} from "@/api/costManagement/expenseSetting.js";
import { getCustomerList } from "@/api/common/common.js";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { arrToJoin, toSelectOptions } from "util/util";
import accountAdjustmentDalog from "./components/accountAdjustment.vue";
export default {
  components: { TwTable, accountAdjustmentDalog },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showResetButton: true,
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        column: [
          // 表格列配置
          {
            prop: "customName",
            label: "客户",
          },
          {
            prop: "feeOrgNo",
            label: "单据号",
            minWidth: "130",
          },
          {
            prop: "warehouseName",
            label: "仓库",
            minWidth: "150",
            minWidth: "150",
          },
          {
            prop: "feeTypeName",
            label: "费用类型",
          },
          {
            prop: "feeItemName",
            label: "费用项",
          },
          {
            prop: "baseTypeText",
            label: "费用来源",
          },{
            prop: "feeSourceNo",
            label: "业务单号",
            minWidth: "140",
          },
          {
            prop: "settlementDateDesc",
            label: "创建时间",
          },
          {
            prop: "amount",
            label: "金额",
          },
          {
            prop: "currency",
            label: "币别",
          },
          {
            prop: "remark",
            label: "备注",
          },
        ],
      },
      showLogFeeDetail: false,
      baseTypesOptions: [
        {
          value: 0,
          label: "系统计算",
        },
        {
          value: 1,
          label: "人工录入",
        },
        {
          value: 2,
          label: "财务调账",
        },
      ],
      searchData: {
        //搜索列配置
        search: [
          {
            type: "select",
            key: "warehouseIds",
            label: "仓库",
            multiple: true,
            options: [],
          },
          {
            type: "select",
            key: "orgIDs",
            label: "客户",
            multiple: true,
            options: [],
          },
          {
            type: "input",
            key: "keys",
            label: "单据号/业务单号",
            clearable: true,
          },
          {
            key: "date",
            type: "daterange",
            label: "创建日期",
          },
         
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "select",
            key: "feeItemIDs",
            label: "费用项",
            multiple: true,
            options: [],
          },

          {
            label: "费用来源",
            key: "baseTypes",
            slot: true,
            
          },
        ],
      },
      //-------------
    };
  },
  methods: {
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    //查询列表
    initTable() {
      const { warehouseIds, orgIDs, baseTypes, date,feeItemIDs } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize || 50,
        ...this.filters,
        warehouseIds: arrToJoin(warehouseIds),
        orgIDs: arrToJoin(orgIDs),
        baseTypes: arrToJoin(baseTypes),
        startdate: date ? date[0] : '',
        enddate: date ? date[1] : '',
        feeItemIDs: arrToJoin(feeItemIDs),
      };
      this.getTableData(GetFeeOrgDetailList, para).then((res) => { });
    },
    //导出
    ExportData() {
      const { warehouseIds, orgIDs, baseTypes, date,feeItemIDs  } = this.filters;

      let row = this.selectRows.rows;
      let list = row
        .map((item) => item.feeOrgDetailID);

      let params = {
        ...this.filters,
        warehouseIds: arrToJoin(warehouseIds),
        orgIDs: arrToJoin(orgIDs),
        baseTypes: arrToJoin(baseTypes),
        startdate: date ? date[0] : '',
        enddate: date ? date[1] : '',
        feeOrgDetailIDs: arrToJoin(list),
        page: 1,
        pageSize: 60001,
        feeItemIDs: arrToJoin(feeItemIDs),
      };
      this.exportFile(FeeOrgDetailExport, params);
    },

    //导出
    ExportDepartmentData() {
      const { warehouseIds, orgIDs, baseTypes, date,feeItemIDs  } = this.filters;
      let params = {
        ...this.filters,
        warehouseIds: arrToJoin(warehouseIds),
        orgIDs: arrToJoin(orgIDs),
        baseTypes: arrToJoin(baseTypes),
        startdate: date ? date[0] : '',
        enddate: date ? date[1] : '',
        page: 1,
        pageSize: 60001,
        feeItemIDs: arrToJoin(feeItemIDs),
      };
      this.exportFile(FeeDepartmentExport, params);
    },

    // 调账
    ChangeBill() {
      if (this.selectRows.rows && this.selectRows.rows.length === 1) {
        this.$refs.accountAdjustmentDalogRef.showDalog(this.selectRows.rows[0]);
      } else {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
      }
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    // 获取搜索栏下拉框数据
    initDropList() {
      // 设置仓库下拉
      let user = JSON.parse(window.localStorage.user);
      this.setSearchOptions(
        "search",
        "warehouseIds",
        toSelectOptions(user.warehouseList, "warehouseId", "warehouseName")
      );
      // 设置客户下拉
      getCustomerList({}).then((res) => {
        this.setSearchOptions(
          "search",
          "orgIDs",
          toSelectOptions(res.data.response, "id", "customName")
        );
      });

      getFeeItemBatchBasis({}).then((res) => {
        this.setSearchOptions(
          "moreSearch",
          "feeItemIDs",
          toSelectOptions(res.data.response.feeItemList, "feeItemID", "feeItemName")
        );
      });

    },
    resetBtn() {
      this.filters = {};
    },
  },

  mounted() {
    // 获取按钮配置
    this.getMixinsButtonList();
    // 获取搜索栏下拉框数据
    this.initDropList();
  },
};
</script>
